import React from "react";
import PropTypes from "prop-types";
import { ListItem, makeStyles, ListItemText, ListItemIcon } from "@material-ui/core";
import clsx from 'clsx';
import Link from './Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  iconContainer: {
    color: 'inherit',
    marginRight: theme.spacing(2),
    minWidth: '30px'
  },
  icon: {
    fontSize: '20px'
  },
  itemPrimary: {
    color: 'rgba(255,255,255,0.7)',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    }
  },
  itemPrimaryActive: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium
  },
}));

const PetsLink = props => {
  const classes = useStyles();
  const { name, path, icon, ...other } = props;
  const { t } = useTranslation();

  return (
    <ListItem
      button
      component={Link}
      to={path}
      className={clsx(classes.itemPrimary)}
      activeClassName={classes.itemPrimaryActive}
      {...other}
    >
      <ListItemIcon className={classes.iconContainer}>
        {/* <Icon className={clsx(classes.icon, icon)}></Icon> */}
        <FontAwesomeIcon icon={icon} className={classes.icon} />
      </ListItemIcon>
      <ListItemText>{t(name)}</ListItemText>
    </ListItem>
  );
};

PetsLink.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  icon: PropTypes.string
};

export default PetsLink;
